import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-availability-event',
  templateUrl: './availability-event.component.html',
  styleUrls: ['./availability-event.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class AvailabilityEventComponent {
  @Input() hidden: boolean = false;
  @Input() child: boolean = false;
}
